export function setWordsCloudAutoColor(option, container){
  if(option && option.name && option.name == '词云图'){
    let bkColor;
    if(option.series[0].randomColor){
      if(option.graphic && option.graphic[0].show){
        bkColor = HEX2RGBA(option.graphic[0].backgroundColor, 1);
      }else if(option.backgroundColor){
        bkColor = option.backgroundColor;
      }else if(container && container.style.background){
        bkColor = container.style.background;
      }
      let rgbs = getColorFromBackground(bkColor);
      let bkBrightness = calcColorBrightness(rgbs);
      if(bkBrightness <= 64){
        option.series[0].textStyle.color = genBrightColor;
      }else if(bkBrightness <= 128){
        option.series[0].textStyle.color = genHighBrightColor;
      }else if(bkBrightness <= 192){
        option.series[0].textStyle.color = genDeepDarkColor;
      }else{
        option.series[0].textStyle.color = genDarkColor;
      }
    }else{
      option.series[0].textStyle.color = option.series[0].textColor;
    }
  }
}

//十进制转化为16进制
export function hex(x){
  return ("0" + parseInt(x).toString(16)).slice(-2);
}

//16进制转化为十进制
export function HEX2DEC(hex){
  return parseInt(hex,16).toString();
}

//十六进制颜色转化为RGB颜色
export function HEX2RGBA(hex,opacity){
  hex = hex.substring(1);
  if(hex.length === 3){
    hex += hex;
  }
  return "rgba("+ HEX2DEC(hex.substring(0,2))+","+ HEX2DEC(hex.substring(2,4))+","+ HEX2DEC(hex.substring(4))+","+opacity+")";
}

export function getColorFromBackground(background){
  if(background == undefined || background == ''){
    return undefined;
  }else{
    let tmp = background
    tmp = tmp.replace('rgba','')
    tmp = tmp.replace('rgb','')
    tmp = tmp.replace('(','')
    tmp = tmp.replace(')','')
    tmp = tmp.replace(' ','')
    let rgbs = tmp.split(",")
    if(rgbs.length >= 3) {
      return rgbs;
    }else{
      return undefined
    }
  }
}

export function isColorDarkThan(rgbs, threshold){
  let brightness = calcColorBrightness(rgbs);
  return brightness <= threshold;
}

export function isColorBrightThan(rgbs, threshold){
  let brightness = calcColorBrightness(rgbs);
  return brightness >= threshold;
}

export function calcColorBrightness(rgbs){
  if(rgbs && rgbs.length >= 3) {
    return parseInt(rgbs[0])*0.299 + parseInt(rgbs[1])*0.587 + parseInt(rgbs[2])*0.114;
  } else {
    return 255;
  }
}

export function genRandomColor() {
  return [
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255),
    Math.round(Math.random() * 255)
  ];
}

export function genColorBrightThan(threshold) {
  threshold = Math.min(255, threshold);
  while(true){
    let rgbs = genRandomColor();
    if(isColorBrightThan(rgbs, threshold)){
      return rgbs;
    }
  }
}

export function genColorDarkThan(threshold) {
  threshold = Math.max(1, threshold);
  while(true){
    let rgbs = genRandomColor();
    if(isColorDarkThan(rgbs, threshold)){
      return rgbs;
    }
  }
}

export function genHighBrightColor() {
  let rgbs = genColorBrightThan(200);
  return 'rgb(' + rgbs.join(',') + ')';
}

export function genBrightColor() {
  let rgbs = genColorBrightThan(140);
  return 'rgb(' + rgbs.join(',') + ')';
}

export function genDarkColor() {
  let rgbs = genColorDarkThan(140);
  return 'rgb(' + rgbs.join(',') + ')';
}

export function genDeepDarkColor() {
  let rgbs = genColorDarkThan(50);
  return 'rgb(' + rgbs.join(',') + ')';
}

